"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileFilteringErrorMessage = exports.getFileFilteringErrorMessageOptions = exports.getFileFilteringErrorMessageKey = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var getFileFilteringErrorMessageKey = function getFileFilteringErrorMessageKey(filterType) {
  return "FileManagerLib.panels.tiles." + filterType;
};

exports.getFileFilteringErrorMessageKey = getFileFilteringErrorMessageKey;

var getFileFilteringErrorMessageOptions = function getFileFilteringErrorMessageOptions(extensions) {
  return {
    count: extensions.count(),
    extensions: _I18n.default.formatList(extensions.map(function (extension) {
      return "." + extension;
    }).toArray())
  };
};

exports.getFileFilteringErrorMessageOptions = getFileFilteringErrorMessageOptions;

var getFileFilteringErrorMessage = function getFileFilteringErrorMessage(extensions, filterType) {
  return _I18n.default.text(getFileFilteringErrorMessageKey(filterType), getFileFilteringErrorMessageOptions(extensions));
};

exports.getFileFilteringErrorMessage = getFileFilteringErrorMessage;